/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SifAuRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return hash({
      connections: this.store.query('sif/au/connection', {
        schoolId: this.get('session.school.id'),
      }),
      zones: this.store.query('sif/au/zone', {
        jurisdiction: this.get('session.school.jurisdiction'),
      }),
    });
  }
}
